module.exports = __webpack_public_path__ + "static/media/mongodb-icon.554c7d4b.svg";